var ja = {
    "languageArr": ["中", "EN", "JPN"],
    "login": "登録",
    "search": {
        "title": "検索",
        "cateArr": ["全部です", "アプリマーケット", "製品紹介", "新着情報"],
        "placeholder": "キーワード検索をお願いします。",
        "record": "歴史的記録です"
    },
    "product_search": {
        "placeholder": "製品名、製品種別、用途などを入力お願いします。",
        "btn": "検索"
    },
    "statistics_arr": ["スキル", "特許件数", "開発センターの面積", "開発担当者", "科学研究機関"],
    "unit_arr": ["項です", "項です", "㎡", "+", "です"],
    "market_language": {
        "title": "アプリマーケット",
        "desc": "ハイエンド無機・非金属粉体材料のアプリケーションとソリューションに注力",
        "market": ["電子情報材料", "新エネルギー材料", "半導体材料", "その他の業界"],
        "btn": "もっと詳しく知ります"
    },
    "product_language": {
        "title": "製品紹介",
        "desc": "お客様を中心として、イノベーションを継続",
        "product": [
            { "name": "シリカ系", "desc": "シリカ微粉、球形シリカ、球形シリカスラリー" }, 
            { "name": "アルミ系", "desc": "角形酸化アルミニウム、球状酸化アルミニウム" }, 
            { "name": "窒化系", "desc": "窒化アルミニウム、窒化ホウ素" },
            { "name": "チタン系", "desc": "単結晶酸化チタン" },
            { "name": "セラミック系", "desc": "チタン酸バリウム、ペタライト" },
            { "name": "電子パステ", "desc": "焼結銅ペースト、硬化銅ペースト" }
        ]
    },
    "group_introduction": {
        "title": "会社紹介",
        "inroduction": {
            "para1": "蘇州州錦芸新材料科技株式会社は2017年に設立され、国家級のの専門的・精密化・特化型新興企業（「小巨人」）に認定されています。当社は先進的な無機非金属粉体材料分野に注力しており、事業の起源は2005年に設立された重慶慶錦芸にに遡ります。20年以上にわたりの努力を重ね、粉体合成、超微細加工、球状製造、表面改質など多岐にわたる技術プラットフォームを構構築し、電子情報、熱伝導・放熱、先進進塗料、リチウム電池などのなどの戦略的新興分野を全面的にカバーしています。特に特に銅箔板用無機機機能性粉体分野では優位性を確立し、長年にわたり業界でで販売規模が常にトップを維持しています。当社の主力製品である電子級高純度超微細球状シリコン微粉は、現在最高レベルの技術を持つを持つ銅箔板（メグトロン8級高速高速銅箔板、IC基板および類似基板（SLP）、AIAIサーバーなど）にに広くく応用されており、高付加価価値な用途に対に対応しています。",
            "para2": "業界をリードするハイエンド粉体材料サプライヤーとして、、錦芸新材は世界的な高品質顧客ネットワークを有しています。電子情報分野では、台光電子、台台燿科技、建滔電子、聯茂電子、南南亜電子、日本パナソニック電工、生益科技、南南亜新材など、世界トップ20の剛性性銅箔板メーカーと長期的かつ安定した協力関係をを築いています。熱伝導・放熱分野では、ハンガガーコンタクトやライアアーディなど国際的に著名な熱伝導界面材料企業とも安定した提携関係をを築いています。さらに、当社製品はリチウム電池セパレーターターや高級級塗料の業界をリードする企業のサプライチェーンにも参入しており、エンジェス株式会社、アクスノボルなど世界有数の企業とも連携しています。",
            "para3": "本社は江蘇省蘇州市に位置し、長江デルタ地域の中心地として、兆元規模の産業クラスターを擁し、最先端の産学研資源が集約されています。当社は各分野のの専門技術人材を積極的に採用し、独自の研究開開発と基盤技術の革新に注力しています。先進無機非金属材料業界のリリーダーとなることを目指し、基礎研究を時代のトレンドとし、重要材料の自主自給・制御を私たちの使命としています。"
        },
    },
    "core_advantage": {
        "title": "2.コアの強み",
        "desc": "顧客価値を創造し、資本を増やす",
        "core_arr": [
            { "name": "多様な専門技術", "desc": "複合調合、超微粉砕<br />精密分級、微細球状化<br />表面処理、特注スラリー<br />" },
            { "name": "様々な無機材料", "desc": "無機的なものをベースに、有機的なものと手を携えて<br />統合と革新、再生と反復<br />" },
            { "name": "リーン生産プラットフォーム", "desc": "融通の利く生産、迅速な納品<br />品質向上、環境保護<br />" },
            { "name": "厳密な品質管理", "desc": "完璧な品質システム<br />高度な検査機器<br />優れた生産設備<br />権威ある試験方法<br />" },
            { "name": "カスタマイズ・ソリューション", "desc": "顧客の要望、共同研究開発<br />共同テスト、業界の優位性<br />" },
            { "name": "オープンな協力プラットフォーム", "desc": "外資系企業、国有企業<br />研究機関、企業家チーム<br />" }
        ]
    },
    "our_growth": {
        "title": "私たちの成長です"
    },
    "company_culture": {
        "title": "企業文化",
        "culture": [
            { "title": "ビジョン", "desc": "ハイエンドの無機非金属材料のアプリケーションとソリューションのプロバイダー" },
            { "title": "ミッション", "desc": "顧客からのプレッシャーと課題に焦点を当て、無機非金属材料の可能性を引き出す" },
            { "title": "価値観", "desc": "顧客本位、革新主導、闘争志向、職人技の実践" }
        ]
    },
    "talent_concept": {
        "title": "人材展望",
        "concept": [
            { "title": "プロフェッショナリズム", "desc": "絶え間ない学習、知識と行動の一体化<br />才能を最大限に生かすことにこだわり、職人精神を実践する" },
            { "title": "エクセレンス", "desc": "進取の気性に富み、卓越を追求し<br />究極のパフォーマンスを追求し、並外れた価値を達成する" },
            { "title": "イノベーション", "desc": "オープンさと寛容さ、変化を受け入れること<br />継続的改善へのコミットメント、革新する勇気に満ちている" }
        ]
    },
    "school": {
        "title": "学校と企業の協力"
    },
    "development": {
        "title": "キャリア育成",
        "desc1": "当社は管理職と専門職の2つのキャリア開発経路を提供しています。 専門チャンネルには、マーケティング、技術、機能、運営の4つの系列が含まれています。",
        "desc2": "デュアルチャンネル・スタッフ・グレード開発システム"
    },
    "salary": {
        "title": "給与パッケージ",
        "salary_arr": [
            { "title": "基本給", "desc": "基本給、業績給、出勤手当、ほかの手当、補助金" },
            { "title": "社会保険", "desc": "会社は全従業員を対象に”5つの保険と1つの金”に入ることを義務づけている" },
            { "title": "ライフサービス", "desc": "宿泊施設、シャトルバス、カフェテリア、スポーツ・フィットネス施設ある" },
            { "title": "報奨金制度", "desc": "期末報奨金、プロジェクト突破報奨金、株式、オプションなど" },
            { "title": "スタッフの能力開発", "desc": "多様な研修プログラムとキャリア開発計画" }
        ],
        "btn": "キャンパス採用"
    },
    "subsidiary": {
        "btn": "/詳細情報"
    },
    "honor": {
        "title": "名誉と資格"
    },
    "wechat_code": "公式マイクロシグナルです",
    "contact": {
        "contact_us": "連絡先",
        "phone": "連絡先",
        "mail": "メール",
        "address": "会社住所",
        "address_detail": "江蘇省常熟市経済技術開発区興港路25-1",
        "copyright": "Copyright©️ 2024蘇州錦芸新材料株式会社",
        "download": "ダウンロード",
        "summary": "サマリー",
        "feature": "特徴",
        "function": "機能"
    },
    "fill_information": {
        "title": "申請資料情報記入",
        "desc": "資料を記入後、関連製品ファイルを自動的にダウンロード",
        "not_null": "必須",
        "name": "名前",
        "unit": "単位名",
        "department": "セクション",
        "mail": "メール",
        "confirm": "確認",
        "phone": "連絡先",
        "query": "クエリー",
        "select": "選択してください",
        "content": "具体的な内容",
        "submit": "確認"
    },
    "read_more": {
        "btn": "詳細"
    }
}

export default ja